import request from '@/utils/request'

export function getProfile() {
  return request.get('/member/profile')
}

export function updateProfile(data) {
  return request.put('/member/profile', data)
}

export function getQuotaBalance() {
  return request.get('/quota/balance')
}

export function getQuotaLogs() {
  return request.get('/quota/logs')
}
